import { validateContainerNumber } from '@planning/rt-stores/helpers'
import { FieldStore, ISubFormStore, optional, required, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export type ContainerCreationFormData = {
  containerNumber: string
  isoCode: string
  tare: string
  maxGross: string
  operator: string
}

export class ContainerCreationFormStore implements ISubFormStore<ContainerCreationFormData> {
  containerNumber: FieldStore<string>
  isoCode: FieldStore<string>
  tare: FieldStore<string>
  maxGross: FieldStore<string>
  operator: FieldStore<string>

  constructor(initialValues?: Partial<ContainerCreationFormData>, isOperatorOptional?: boolean) {
    makeObservable(this)

    this.containerNumber = new FieldStore(initialValues?.containerNumber ?? '', required())
    this.isoCode = new FieldStore(initialValues?.isoCode ?? '', required())
    this.tare = new FieldStore(initialValues?.tare ?? '')
    this.maxGross = new FieldStore(initialValues?.maxGross ?? '')
    this.operator = new FieldStore(
      initialValues?.operator ?? '',
      isOperatorOptional ? optional() : required(),
    )
  }

  validate = () => validateSubForm(this)

  get data(): ContainerCreationFormData {
    return {
      containerNumber: this.containerNumber.value,
      isoCode: this.isoCode.value,
      tare: this.tare.value,
      maxGross: this.maxGross.value,
      operator: this.operator.value,
    }
  }

  requiredAndValidContainer = (val?: string): string | undefined => {
    if (val === null || val === '' || val === undefined) {
      return 'fieldIsRequired'
    }
    if (!validateContainerNumber(val)) {
      return 'invalidContainerNumber'
    }
    return undefined
  }
}
